import { render, staticRenderFns } from "./firmwarenew.vue?vue&type=template&id=483f5cba&scoped=true&"
import script from "./firmwarenew.vue?vue&type=script&lang=js&"
export * from "./firmwarenew.vue?vue&type=script&lang=js&"
import style0 from "./firmwarenew.vue?vue&type=style&index=0&id=483f5cba&lang=less&scoped=true&"
import style1 from "./firmwarenew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f5cba",
  null
  
)

export default component.exports